import { render, staticRenderFns } from "./ArticlesAdminHome.vue?vue&type=template&id=33dab75f"
import script from "./ArticlesAdminHome.vue?vue&type=script&lang=js"
export * from "./ArticlesAdminHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports